<div class="card-container">
  <div class="card-header">
    {{ 'global.instrumentChartHeader' | translate }}
  </div>
  @if (cardData && cardData.chartData.length >= 1) {
    @if (doughnutChartData) {
      <div class="chart-container">
        <canvas
          baseChart
          [data]="doughnutChartData"
          [options]="doughnutChartOptions"
          [type]="'doughnut'"
          [legend]="false"
          >
        </canvas>
      </div>
    }
  } @else {
    <div class="no-instruments">
      {{ 'global.error.noInstrumentsSelected' | translate }}
    </div>
  }

  <div class="row instruments-container">
    <div class="col-5">
      <div class="table-label table-label--instrument">
        {{ 'global.instrument' | translate }}
      </div>
    </div>
    <div class="col-7">
      <div class="table-label table-label--value">
        {{ 'global.investmentValue' | translate }}
      </div>
    </div>
  </div>

  <hr class="divider">

  @for (dropdown of dropdownData; track $index) {
    <div class="dropdown-container">
      <libero-instrument-chart-dropdown [dropdownInput]="dropdown"></libero-instrument-chart-dropdown>
      <hr class="divider">
    </div>
  }
</div>
